import ProductSections from "./components/ProductSections";

export default ProductSections;
